import { render, staticRenderFns } from "./VLabelField.vue?vue&type=template&id=4b6d0172"
import script from "./VLabelField.vue?vue&type=script&lang=js"
export * from "./VLabelField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports